import { db } from '../firebase/';
import firebase from 'firebase';

export default {
  data() {
    return {
      authUser: null
    };
  },
  firebase: {
    oscarYears: {
      source: db.ref('years')
    }
  },
  computed: {
    isAuthenticated() {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.authUser = user;
          this.$firebaseRefs.oscarYears.child(this.currentYear['.key']).child('year').child('votes').child(user.uid).child('displayName').set(user.displayName);
        } else {
          this.authUser = null;
        }
      });

      return (this.authUser !== null);
    },
    currentYear() {
      if (this.oscarYears) {
        return this.oscarYears.find(year => year.year.name === (new Date()).getFullYear());
      }
      return { };
    },
    currentYearCategories() {
      let categories = [];

      let sortedCategories = [];
      const currentYear = this.oscarYears.find(year => year.year.name === (new Date()).getFullYear());
      if (currentYear) {
        for (let category in currentYear.year.categories) {
          categories.push({
            '.key': category,
            name: currentYear.year.categories[category].name,
            order: currentYear.year.categories[category].order,
            nominees: currentYear.year.categories[category].nominees
          });
        }
        sortedCategories = [...categories].sort((one, two) => { return one.order - two.order; });
      }

      return sortedCategories;
    }
  }
};
